export const CONSUMABLES_ONBOARDING_RESTOKING_INFO_ACTION = 'consumables_onboarding_restocking_info';
export const CONSUMABLES_ONBOARDING_SUBSCRIPTION_STARTED_ACTION = 'consumables_onboarding_subscription_started';

export const BASIC_PRODUCTS_MPNs: string[] = [
  '08664',
  '35110',
  '12456PK',
  '6405',
  '02312',
  '30686',
  '40125',
  '40120',
  '651311',
  '24394127',
  '426',
  '44986',
  '50319',
  '60052101',
  '8845'
];
export const PREMIUM_PRODUCTS_MPNs: string[] = [
  ...BASIC_PRODUCTS_MPNs,
  '49650',
  '156184',
  '20378',
  '10051',
  '87635',
  'SM2681146'
];
